import { Badge } from '@/components/ui/badge';
import { Users } from 'lucide-react';
import { useTeams } from '@/hooks/useTeams';
import { useMultiTeam } from '@/hooks/useMultiTeam';

interface TeamBadgeProps {
  teamId?: string | null;
  size?: 'sm' | 'default';
}

/**
 * Displays a team badge. Only visible when multi-team is enabled.
 */
export function TeamBadge({ teamId, size = 'default' }: TeamBadgeProps) {
  const { isMultiTeamEnabled } = useMultiTeam();
  const { teams } = useTeams();

  // Don't render if multi-team is not enabled or no team assigned
  if (!isMultiTeamEnabled || !teamId) {
    return null;
  }

  const team = teams.find(t => t.id === teamId);
  
  if (!team) {
    return null;
  }

  return (
    <Badge 
      variant="outline" 
      className={size === 'sm' ? 'text-[10px] px-1.5 py-0' : 'text-xs'}
    >
      <Users className={size === 'sm' ? 'h-2.5 w-2.5 mr-0.5' : 'h-3 w-3 mr-1'} />
      {team.name}
    </Badge>
  );
}
